export default __webpack_public_path__ + "static/side-navigation-82987696811ab964616b8aee34805f1a.png";